import constant from '../../../../utils/constants';
import { debounce, usePagination } from '../../../../utils/commonFunctions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../../../app/redux/hooks';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Skeleton,
  Tooltip,
  Typography
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CustomTextField from '../../../../common/components/customized/customtextfield/CustomTextField';
import CustomButton from '../../../../common/components/buttons/CustomButton';
import CustomDeletePopup from '../../../../common/components/customdelete/CustomDeletePopup';
import CustomActivatePopup from '../../../../common/components/customactive/CustomActivatePopup';
import AddLoadConfig from './AddLoadConfig';
import {
  deactivateLoadConfig,
  deleteLoadConfig,
  getLoadsConfigAction
} from '../../redux/reducer/deliveryTrackingSlices/loadConfigSlice';
import './LoadConfig.scss';
import InfiniteScroll from '../../../../common/components/infinitescroll/InfiniteScroll';
import Custom3dWrapper from '../3dModels/CustomWrapper';
import loader from '../../../../app/assets/gifs/loader1.gif';
interface FormValues {
  search: string;
}

const LoadConfig: React.FC = ({ onScroll, setApi, clearState }: any) => {
  const dispatch = useAppDispatch();
  const {
    data: loadConfigs,
    isLoading,
    error,
    count
  } = useAppSelector(state => state.loadConfig);

  const [openAddConfigLoad, setOpenAddConfigLoad] = useState(false);
  const [selectedLoadConfig, setSelectedLoadConfig] = useState<any | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [activateOpen, setActivateOpen] = useState(false);
  const [loadConfigData, setLoadConfigData] = useState<any>([]);
  const [isScroll, setIsScroll] = useState<boolean>(false);
  const inputRef = useRef<any>();

  const { control } = useForm<FormValues>({
    defaultValues: { search: '' }
  });

  const handleClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditLoadConfig = (loadConfig: any) => {
    setOpenAddConfigLoad(true);
    setAnchorEl(null);
  };

  const handleDeleteLoadConfig = async () => {
    if (selectedLoadConfig && selectedLoadConfig.id) {
      const response = await dispatch(
        deleteLoadConfig({ id: Number(selectedLoadConfig.id), pageNo: 1, pageSize: 20 })
      );
      if (deleteLoadConfig.fulfilled.match(response)) {
        setOpen(false);
        setMessage('');
        dispatch(getLoadsConfigAction({ pageNo: 1, pageSize: 20, search: filter }));
      }
    }
  };

  const handleDeactivateLoadConfig = async () => {
    if (selectedLoadConfig && selectedLoadConfig.id) {
      const response = await dispatch(
        deactivateLoadConfig({
          id: Number(selectedLoadConfig.id),
          pageNo: 1,
          pageSize: 20
        })
      );
      if (deactivateLoadConfig.fulfilled.match(response)) {
        setActivateOpen(false);
        setMessage('');
        dispatch(getLoadsConfigAction({ pageNo: 1, pageSize: 20, search: filter }));
      }
    }
  };

  const handleFilterChange = useCallback(
    debounce((event: string) => {
      setFilter(event);
      dispatch(getLoadsConfigAction({ pageNo: 1, pageSize: 20, search: event }));
    }),
    [dispatch]
  );
  const handleInfinitePagination = async (pageNo: number) => {
    setIsScroll(true);
    await dispatch(getLoadsConfigAction({ pageNo: pageNo, pageSize: 12 }));
  };
  const availableLoadsConfig = useCallback(() => {
    if (isScroll) {
      setLoadConfigData((prev: any) => [...loadConfigData, ...loadConfigs]);
    } else {
      setLoadConfigData(loadConfigs);
    }
  }, [loadConfigs, loadConfigData]);

  useEffect(() => {
    if (loadConfigs?.length > 0) {
      availableLoadsConfig();
    }
  }, [loadConfigs]);

  useEffect(() => {
    setApi({
      handlePagination: handleInfinitePagination,
      fetchedData: loadConfigData,
      count: count
    });
  }, [loadConfigData, count]);
  useEffect(() => {
    dispatch(getLoadsConfigAction({ pageNo: 1, pageSize: 12, search: filter }));
  }, []);

  return (
    <Box
      className='load-configuration-container'
      onScroll={() => {
        const { scrollTop, scrollHeight, clientHeight } = inputRef.current;
        const data = { scrollTop, scrollHeight, clientHeight };
        onScroll(data);
      }}
      ref={inputRef}
    >
      <Box className='tab-content'>
        <Box className='load-config-header'>
          <Box className='load-config-header-actions'>
            <CustomButton
              className='saveChanges'
              category='Add Load Config'
              onClick={() => {
                setOpenAddConfigLoad(true);
                setSelectedLoadConfig(null);
              }}
            />
            {/* <Box sx={{ width: 200 }}>
              <CustomTextField
                name='search'
                control={control}
                id='filter-input'
                placeholder='Search...'
                variant='standard'
                icon={<SearchOutlinedIcon color='primary' />}
                onChangeCallback={handleFilterChange}
              />
            </Box> */}
          </Box>
        </Box>

        {isLoading.getLoading && !isScroll && (
          <Grid container spacing={3}>
            {[...Array(9)].map((_, index) => (
              <Grid item xs={10} sm={5} lg={3.9} spacing={2} padding={'5px'}>
                <Card
                  key={index}
                  sx={{ width: '100%', height: '100px', display: 'flex' }}
                >
                  <Box height={'100px'} padding={'5px'}>
                    <Skeleton variant='rectangular' width={100} height={'90px'} />
                  </Box>
                  <Box>
                    <Skeleton variant='text' width={200} height={40} />
                    <Skeleton variant='text' width={180} height={20} sx={{ mt: 0.5 }} />
                    <Box display={'flex'} justifyContent={'space-between'} gap={3}>
                      <Skeleton variant='text' width={80} height={20} />
                      <Skeleton variant='text' width={80} height={20} />
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
        {loadConfigData && loadConfigData.length > 0 ? (
          <Box>
            <Grid container spacing={3}>
              {loadConfigData?.map((loadConfig: any) => (
                <Grid item xs={12} sm={6} lg={3.9} key={loadConfig.id}>
                  <Card
                    key={loadConfig.id}
                    sx={{ position: 'relative', mt: 1, cursor: 'pointer' }}
                    className={`load-card `}
                  >
                    <Grid container>
                      <Grid item xs={3} sx={{ width: '100px', height: '100px' }}>
                        {loadConfig && (
                          <Custom3dWrapper
                            loads={[]}
                            container={{
                              width: Number(loadConfig.width),
                              height: Number(loadConfig.height),
                              depth: Number(loadConfig.depth)
                            }}
                          />
                        )}
                      </Grid>
                      <Grid item xs={7.8} sx={{ ml: 2, mt: 2 }}>
                        <Box sx={{ display: 'flex' }}>
                          <Typography className='load-id'>LoadConfigID</Typography>
                          <Typography className='load-id' sx={{ ml: 0.5 }}>
                            :
                          </Typography>
                          <Tooltip title={loadConfig.loadName}>
                            <Typography noWrap className='load-text'>
                              {loadConfig.id}
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Box sx={{ display: 'flex' }}>
                          <Typography className='load-id mt1'>Dimensions</Typography>
                          <Typography className='load-id' sx={{ ml: 1.5 }}>
                            :
                          </Typography>
                          <Typography noWrap className='load-text mt1'>
                            {loadConfig.width} x {loadConfig.depth} x {loadConfig.height}{' '}
                            mm
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex' }}>
                            <Typography className='load-id mt1'>Quantity</Typography>
                            <Typography className='load-id' sx={{ ml: 1.2 }}>
                              :
                            </Typography>
                            <Tooltip title={loadConfig.quantityLimit}>
                              <Typography noWrap className='load-text mt1'>
                                {loadConfig.quantityLimit}
                              </Typography>
                            </Tooltip>
                          </Box>
                          <Box sx={{ display: 'flex' }}>
                            <Typography className='load-id mt1'>Weight</Typography>
                            <Typography className='load-id' sx={{ ml: 1.2 }}>
                              :
                            </Typography>
                            <Tooltip title={loadConfig.weight}>
                              <Typography noWrap className='load-text mt1'>
                                {loadConfig.weight}
                                {/* {loadConfig.ordersResponses.reduce(
                                  (sum: number, item: any) => sum + item.totalBoxesCount,
                                  0
                                )} */}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={0.5}>
                        <Icon
                          icon='majesticons:more-menu-vertical'
                          width='24'
                          height='24'
                          id='basic-button'
                          aria-controls='true'
                          onClick={(event: any) => {
                            handleClick(event);
                            setSelectedLoadConfig(loadConfig);
                            event.stopPropagation();
                          }}
                        />
                      </Grid>

                      <Menu
                        id='basic-menu'
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button'
                        }}
                      >
                        <>
                          <MenuItem
                            className='menu-dialog'
                            onClick={e => {
                              handleEditLoadConfig(loadConfig);
                            }}
                            disabled={selectedLoadConfig?.isActive === 0 ? true : false}
                          >
                            <Icon icon='ic:baseline-edit' className='menu-icon update' />
                            {constant.Update}
                          </MenuItem>
                          <MenuItem
                            className='menu-dialog'
                            onClick={() => {
                              handleMenuClose();
                              setActivateOpen(true);
                            }}
                          >
                            {selectedLoadConfig?.isActive === 0 ? (
                              <Icon
                                icon='hugeicons:tick-01'
                                color='green'
                                className='menu-icon'
                              />
                            ) : (
                              <Icon icon='gg:block' color='black' className='menu-icon' />
                            )}
                            {selectedLoadConfig?.isActive === 0
                              ? constant.ActiveStatus
                              : constant.Deactive}
                          </MenuItem>
                          <MenuItem
                            className='menu-dialog'
                            onClick={() => {
                              handleMenuClose();
                              setOpen(true);
                              setMessage('Are you sure want to Delete the Load Config');
                            }}
                            disabled={selectedLoadConfig?.isActive === 0 ? true : false}
                          >
                            <Icon
                              icon='ic:outline-delete'
                              className='menu-icon'
                              style={{ color: '#FF4343' }}
                            />
                            {constant.Delete}
                          </MenuItem>
                        </>
                      </Menu>
                    </Grid>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : (
          <Box className='no-loads'>
            <Typography className='text'>No Load Configurations Found</Typography>
          </Box>
        )}

        {isLoading.getLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img src={loader} alt='not found' />
          </Box>
        )}

        {open && (
          <CustomDeletePopup
            open={open}
            setOpen={setOpen}
            handleClose={() => setOpen(false)}
            message={message}
            handleDelete={handleDeleteLoadConfig}
            isLoading={isLoading.deleteLoading}
          />
        )}
        {activateOpen && (
          <CustomActivatePopup
            open={activateOpen}
            setOpen={setActivateOpen}
            filteredRow={selectedLoadConfig}
            handleDeactivate={handleDeactivateLoadConfig}
            isLoading={isLoading.deactivateLoading}
          />
        )}
        {openAddConfigLoad && (
          <AddLoadConfig
            isOpen={openAddConfigLoad}
            setIsOpen={setOpenAddConfigLoad}
            selected={selectedLoadConfig}
            loading={selectedLoadConfig ? isLoading.updateLoading : isLoading.addLoading}
          />
        )}
      </Box>
    </Box>
  );
};

export default InfiniteScroll(LoadConfig);
